import React, { useContext } from 'react';
import styled from 'styled-components';
import { ThemeContext } from 'context/themeContext';
import CartHeader from './cart-header';
import CartButton from './cart-button';
import { OrdersWrapper } from './style';
import PaymentInfo from 'containers/checkout/components/left-side/payment-info';
import { OrderWrapper, OrderWrapperBox } from './style';
import Loading from 'components/loading';

const Wrapper = styled.div`
  opacity: ${(props) => (props.display ? '1' : '0')};
  visibility: ${(props) => (props.display ? 'visible' : 'hidden')};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  transition: 200ms ease-in-out;
`;

const App = (props) => {
  const { theme, rtlDirection } = useContext(ThemeContext);
  const {
    totalPrice,
    partsNumber,
    display,
    ordersArray,
    setShowBasket,
    checkoutMode,
    loadingCreateOrder,
    orderRFQ
  } = props;
  return (
    <>
      {!checkoutMode ? (
        <Wrapper display={display}>
          <CartHeader partsNumber={partsNumber} />
          <OrdersWrapper rtlDirection={rtlDirection} theme={theme}>
            {loadingCreateOrder && (
              <OrderWrapper theme={theme}>
                <OrderWrapperBox>
                  <Loading width="21.118vw" height="7.391vw" borderRadius="1.56vw" />
                </OrderWrapperBox>
              </OrderWrapper>
            )}
            {ordersArray}
          </OrdersWrapper>
          <CartButton setShowBasket={setShowBasket} totalPrice={totalPrice} orderRFQ={orderRFQ}/>
        </Wrapper>
      ) : (
        <>
          <OrdersWrapper rtlDirection={rtlDirection} checkoutMode={checkoutMode} theme={theme}>
            {ordersArray}
          </OrdersWrapper>
          <PaymentInfo totalPrice={totalPrice} orderRFQ={orderRFQ}/>
        </>
      )}
    </>
  );
};

export default App;
